module.exports = __webpack_public_path__ + "static/media/checklist.c5fd1bd3.png";